(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').directive('apAutofocus', ['$timeout', function($timeout) {
        return {
            scope: { 
                autoFocus: '=apAutofocus' 
            },
            link: function(scope, element) {
                if(scope.autoFocus) { 
                  $timeout(function() {
                    element[0].focus();
                  });
                }
            }
        };
    }]);

})(window.angular);
